import React, { useEffect, useRef, useState } from "react";
import videojs from "video.js";

import "video.js/dist/video-js.css";
import "videojs-contrib-hls";

interface VideoPlayerProps {
  src: string;
  type: string;
  setPlayerMain?: any;
  setCurrentTime?: any;
  currentTime?: number;
}

const PLAYER_CLASSES = [
  "video-js",
  "vjs-big-play-centered",
  "vjs-default-skin"
];

export const HlsVideoPlayer = ({
  src,
  type,
  setPlayerMain,
  setCurrentTime,
  currentTime
}: VideoPlayerProps) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [player, setPlayer] = useState<ReturnType<typeof videojs>>();

  const hello = () => {
    setCurrentTime(player?.currentTime());
  };

  useEffect(() => {
    if (!videoRef.current) return;

    const playerInstance = videojs(videoRef.current, {
      responsive: true,
      autoplay: true,
      muted: false,
      controls: true,
      fluid: true,
      fill: true,
      poster: false,
      controlBar: {
        liveDisplay: true,
        pictureInPictureToggle: false
      },
      html5: {
        hls: {
          overrideNative: !videojs.browser.IS_SAFARI,
          withCredentials: false
        }
      }
    });

    setPlayer(playerInstance);
    setPlayerMain(playerInstance);

    //playerInstance.on("timeupdate", hello);

    return () => {
      if (player) {
        player.dispose();
        setPlayer(undefined);
      }
    };
  }, [videoRef, player, setPlayerMain]);

  useEffect(() => {
    player?.src({ type: type, src: src });
  }, [player, src, type]);

  return (
    <div className="video-player">
      <video
        ref={videoRef}
        className={PLAYER_CLASSES.join(" ")}
        width={"100%"}
        height={"100%"}
        preload="auto"
        controls
      />
    </div>
  );
};
